export default __webpack_public_path__ + "static/media/sidebar@3x.ed71da54.jpg";